"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var preact_1 = require("preact");
var Modal_1 = require("./components/Modal");
var requests_1 = require("./requests");
var helper_1 = require("./helper");
var Estimate = /** @class */ (function () {
    function Estimate(estimateBody, config, el) {
        this.estimateBody = estimateBody;
        this.config = config;
        this.el = el;
        this.isReady = false;
        this.isOpen = false;
        this.addedOrientationChangeListener = false;
    }
    Estimate.prototype.open = function () {
        var _this = this;
        if (!this.addedOrientationChangeListener) {
            window.screen.orientation.addEventListener('change', function () {
                (0, helper_1.applySmallMobileStyling)(_this.config);
                if (_this.isOpen) {
                    _this.render();
                }
            });
            this.addedOrientationChangeListener = true;
        }
        this.render();
        this.isOpen = true;
    };
    Estimate.prototype.render = function () {
        var _a;
        (0, preact_1.render)((0, jsx_runtime_1.jsx)(Modal_1.Modal, { onClose: (_a = this.config.onClose) !== null && _a !== void 0 ? _a : this.onClose.bind(this), estimateBody: this.estimateBody, config: this.config }), this.el);
    };
    Estimate.prototype.close = function () {
        (0, preact_1.render)((0, jsx_runtime_1.jsx)("div", {}), this.el);
        this.isOpen = false;
    };
    Estimate.prototype.onClose = function (e) {
        e.preventDefault();
        this.close();
        this.isOpen = false;
    };
    Estimate.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, requests_1.validateEstimateBody)(this.config, this.estimateBody)];
                    case 1:
                        errors = _a.sent();
                        if (errors && Object.keys(errors).length > 0) {
                            return [2 /*return*/, Promise.reject(errors)];
                        }
                        this.isReady = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    return Estimate;
}());
exports.default = Estimate;
